(function () {
  function formatMoney(cents) {
    const formatter = new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: Shopify.currency.active
    });

    return formatter.format((cents || 0) / 100);
  }

  function parseVariants(element) {
    const raw = element.dataset.variants;
    if (!raw) return [];

    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function dispatchBundleVariantChange(productId, variantId) {
    document.dispatchEvent(
      new CustomEvent('bundle:variant-change', {
        detail: {
          productId: String(productId),
          variantId: String(variantId)
        }
      })
    );
  }

  function dispatchBundleQuantityChange(productId, quantity) {
    document.dispatchEvent(
      new CustomEvent('bundle:quantity-change', {
        detail: {
          productId: String(productId),
          quantity: String(quantity)
        }
      })
    );
  }

  function getHeroQuantity() {
    const heroQty = document.querySelector('[data-bundle-pdp] input[name="quantity"]');
    return Math.max(1, parseInt(heroQty?.value, 10) || 1);
  }

  function initBundlePdp(section) {
    if (section.dataset.bundlePdpInitialized === 'true') return;
    section.dataset.bundlePdpInitialized = 'true';

    const form = section.querySelector('form');
    if (!form) return;

    const productId = section.dataset.productId;
    const variants = parseVariants(section);
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');

    const priceEl = section.querySelector('[data-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');
    const savingEl = section.querySelector('[data-saving]');
    const swatches = section.querySelectorAll('.bundle-pdp__swatch');

    function updateVariant(variantId) {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (savingEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const savings = variant.compare_at_price - variant.price;
          const percent = Math.round((savings * 100) / variant.compare_at_price);
          savingEl.textContent = 'Save ' + percent + '%';
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }

      swatches.forEach((swatch) => {
        swatch.classList.toggle('is-active', String(swatch.dataset.variantId) === String(variant.id));
      });

      dispatchBundleVariantChange(productId, variant.id);
    }

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        const optionValue = this.dataset.optionValue;
        const nativePicker = section.querySelector('.bundle-pdp__native-picker');

        if (nativePicker && optionValue) {
          const nativeInputs = nativePicker.querySelectorAll(
            `[data-option-position="${Number(section.dataset.colorOptionPosition || 1)}"]`
          );

          let matchedInput = null;

          nativeInputs.forEach((input) => {
            const label = nativePicker.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.textContent.trim() : '';

            if (
              labelText.toLowerCase() === optionValue.toLowerCase() ||
              String(input.value).toLowerCase() === optionValue.toLowerCase()
            ) {
              matchedInput = input;
            }
          });

          if (matchedInput) {
            matchedInput.checked = true;
            matchedInput.dispatchEvent(new Event('input', { bubbles: true }));
            matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        updateVariant(variantId);
      });
    });

    if (quantityInput) {
      const emitQuantity = () => {
        const quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
        quantityInput.value = String(quantity);

        document.documentElement.dataset.bundleQuantity = String(quantity);
        dispatchBundleQuantityChange(productId, quantity);
      };

      quantityInput.addEventListener('input', emitQuantity);
      quantityInput.addEventListener('change', emitQuantity);
      emitQuantity();
    }

    if (variantInput && variantInput.value) {
      dispatchBundleVariantChange(productId, variantInput.value);
    }
  }

  function initBundleSync(section) {
    if (section.dataset.bundleSyncInitialized === 'true') return;
    section.dataset.bundleSyncInitialized = 'true';

    const productId = section.dataset.productId;
    const variants = parseVariants(section);

    const form = section.querySelector('form');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    const priceEl = section.querySelector('.value-stack__bundle-price, [data-final-price]');

    if (!variantInput) return;

    function getOrCreateQuantityInput() {
      let input = form.querySelector('[data-bundle-sync-quantity]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.value = '1';
        input.setAttribute('data-bundle-sync-quantity', '');
        form.appendChild(input);
      }
      return input;
    }

    function applyQuantity(quantity) {
      const safeQuantity = Math.max(1, parseInt(quantity, 10) || 1);
      const quantityInput = getOrCreateQuantityInput();
      quantityInput.value = String(safeQuantity);
    }

    function applyVariant(variantId) {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
    }

    document.addEventListener('bundle:variant-change', function (event) {
      if (!event.detail) return;
      if (String(event.detail.productId) !== String(productId)) return;

      applyVariant(event.detail.variantId);
    });

    document.addEventListener('bundle:quantity-change', function (event) {
      if (!event.detail) return;
      if (String(event.detail.productId) !== String(productId)) return;

      applyQuantity(event.detail.quantity);
    });

    form.addEventListener(
      'submit',
      function () {
        applyQuantity(getHeroQuantity());
      },
      true
    );

    applyQuantity(document.documentElement.dataset.bundleQuantity || getHeroQuantity());
  }

  function initBundleFaq(section) {
    if (section.dataset.bundleFaqInitialized === 'true') return;
    section.dataset.bundleFaqInitialized = 'true';

    const items = section.querySelectorAll('.faq__item');

    items.forEach((item) => {
      const trigger = item.querySelector('.faq__question');
      const panel = item.querySelector('.faq__answer');

      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          const otherTrigger = otherItem.querySelector('.faq__question');
          const otherPanel = otherItem.querySelector('.faq__answer');

          otherItem.classList.remove('is-open');

          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initBundlePage() {
    document.querySelectorAll('[data-bundle-pdp]').forEach(initBundlePdp);
    document.querySelectorAll('[data-bundle-sync]').forEach(initBundleSync);
    document.querySelectorAll('.faq').forEach(initBundleFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlePage);
  } else {
    initBundlePage();
  }

  document.addEventListener('shopify:section:load', initBundlePage);
})();